import React, { useEffect, useState } from 'react'
import '../spare/cu-spare.scss'
import NormalInput from '../../common/inputs/NormalInput'
import SelectInput from '../../common/inputs/SelectInput'
import { productTypes } from '../../../assets/javascript/const-data'
import { customerAxios } from '../../../config/axios'
import toast from 'react-hot-toast'


const CUComponent = ({ currentData, setModal, setData, isEdit }) => {
    const [form, setForm] = useState({})

    const handleChange = (e) => {

        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const body = {
            label: form?.label || null,
            for_use: form?.for_use || [],
            default_rate: Number(form?.default_rate) || 0
        }

        if (isEdit) {
            customerAxios.put(`/production-v0/bundled-component/${currentData?.uuid}`, body).then(() => {
                setModal({ status: false })

                setData((state) => state.map((item) => {
                    if (item?.uuid === currentData?.uuid) {
                        return {
                            ...item,
                            ...body
                        }
                    }
                    return item
                }))

                toast.success(`Component Updated! `)

            }).catch((error) => {
                toast.error(error.message)
            })
        } else {
            // Create 

            customerAxios.post(`/production-v0/bundled-component`, body).then((res) => {
                setData((state) => [
                    res?.data,
                    ...state,
                ])
                setModal({ status: false })
                toast.success(`Component Created!`)

            }).catch((error) => {
                toast.error(error.message)
            })
        }
    }

    useEffect(() => {
        if (isEdit) {
            const temp = {
                label: currentData?.label,
                for_use: currentData?.for_use || [],
                default_rate: currentData?.default_rate || 0
            }

            setForm(temp)
        }

        // eslint-disable-next-line
    }, [currentData])


    return (
        <div className="cu-spare-sub-div">
            <form action="" onSubmit={handleSubmit}>
                <div className="input-group-div" style={{ gridTemplateColumns: "1fr" }}>
                    <NormalInput label='Label *' name='label' value={form?.label} onChangeFun={handleChange} />
                    <SelectInput label='Product Type *' name='for_use' values={productTypes?.map((u) => ({ option: u, value: u, selected: u === form?.for_use }))}
                        onChangeFun={handleChange} firstOption={{ option: 'Choose...', value: '' }} />
                    <NormalInput label='Default Rate *' type={'number'} name='default_rate' value={form?.default_rate} onChangeFun={handleChange} min={0} />
                </div>

                <button>Submit</button>
            </form>
        </div>
    )
}

export default CUComponent